import Keycloak from "keycloak-js";
import * as Constants from "common/constants";

let keycloak = null;

async function getDomainName() {
	const domainName = window.location.hostname;
	const endPoint = `${Constants.GetDomainEndPoint}/${domainName}`;

	try {
		const response = await fetch(endPoint, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		});
		return await response.json();
	} catch (err) {
		console.log(err.message);
		throw err;
	}
}

async function getKeycloakInstance() {
	if (!keycloak) {
		const domainNameResponse = await getDomainName();
		keycloak = new Keycloak({
			url: domainNameResponse.KeycloakBaseUrl,
			realm: domainNameResponse.KeycloakRealm,
			clientId: domainNameResponse.KeycloakClientId,
			redirectUri: Constants.RedirectUri,
		});
	}
	return keycloak;
}

export default getKeycloakInstance;
